var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrenTaita2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.34 64.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#981c1f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.72,29.54a.57.57,0,0,1-.52-.32l-2.75-5.38H28.86l-1,1.81a.6.6,0,0,1-.52.31H22a.59.59,0,1,1,0-1.18h5L28,23a.6.6,0,0,1,.52-.31h7.29a.6.6,0,0,1,.52.32l2.91,5.71a.58.58,0,0,1-.25.79A.66.66,0,0,1,38.72,29.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.89,52.63a.55.55,0,0,1-.41-.18L32.19,33.17a.59.59,0,0,1,.83-.83L52.31,51.62a.59.59,0,0,1,0,.83A.59.59,0,0,1,51.89,52.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53,40a.56.56,0,0,1-.41-.17l-8.12-8a7.73,7.73,0,0,0-10.93,0l-.94.94a.59.59,0,0,1-.83-.83L32.7,31a8.91,8.91,0,0,1,12.59,0L53.41,39a.59.59,0,0,1,0,.83A.57.57,0,0,1,53,40Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.24,53.75H15.1a4.36,4.36,0,0,1-4.35-4.36V15.25A4.35,4.35,0,0,1,15.1,10.9H49.24a4.36,4.36,0,0,1,4.36,4.35V49.39A4.36,4.36,0,0,1,49.24,53.75ZM15.1,12.07a3.19,3.19,0,0,0-3.18,3.18V49.39a3.19,3.19,0,0,0,3.18,3.19H49.24a3.19,3.19,0,0,0,3.19-3.19V15.25a3.19,3.19,0,0,0-3.19-3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.05,63.28H7.3A6.08,6.08,0,0,1,1.22,57.2V7.45A6.08,6.08,0,0,1,7.3,1.37H57.05a6.08,6.08,0,0,1,6.08,6.08V57.2A6.09,6.09,0,0,1,57.05,63.28ZM7.3,2.54A4.91,4.91,0,0,0,2.39,7.45V57.2A4.91,4.91,0,0,0,7.3,62.11H57.05A4.91,4.91,0,0,0,62,57.2V7.45a4.91,4.91,0,0,0-4.91-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.64,33.37a.58.58,0,0,1-.42-.17l-5-5a7.74,7.74,0,0,0-10.93,0l-4.54,4.52a.59.59,0,0,1-.83,0,.59.59,0,0,1,0-.83l4.54-4.51a8.91,8.91,0,0,1,12.59,0l5,5a.59.59,0,0,1,0,.83A.54.54,0,0,1,32.64,33.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.25,59.72H49.88a.44.44,0,0,1-.44-.44.43.43,0,0,1,.44-.44h4.37a4.44,4.44,0,0,0,4.44-4.44V50a.43.43,0,0,1,.44-.44.44.44,0,0,1,.44.44V54.4A5.33,5.33,0,0,1,54.25,59.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.13,15.06a.44.44,0,0,1-.44-.44V10.25a4.44,4.44,0,0,0-4.44-4.44H49.88a.44.44,0,0,1,0-.88h4.37a5.32,5.32,0,0,1,5.32,5.32v4.37A.44.44,0,0,1,59.13,15.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.47,59.72H10.1A5.33,5.33,0,0,1,4.78,54.4V50a.44.44,0,0,1,.88,0V54.4a4.44,4.44,0,0,0,4.44,4.44h4.37a.44.44,0,0,1,.44.44A.44.44,0,0,1,14.47,59.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.22,15.06a.44.44,0,0,1-.44-.44V10.25A5.32,5.32,0,0,1,10.1,4.93h4.37a.44.44,0,1,1,0,.88H10.1a4.44,4.44,0,0,0-4.44,4.44v4.37A.44.44,0,0,1,5.22,15.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.47,57H12.3a4.83,4.83,0,0,1-4.82-4.83V50a.43.43,0,0,1,.44-.44.44.44,0,0,1,.44.44v2.16a4,4,0,0,0,3.94,4h2.17a.44.44,0,1,1,0,.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.43,15.06a.44.44,0,0,1-.44-.44V12.45a4,4,0,0,0-4-3.94H49.88a.44.44,0,0,1-.44-.44.43.43,0,0,1,.44-.44H52a4.83,4.83,0,0,1,4.83,4.82v2.17A.44.44,0,0,1,56.43,15.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52,57H49.88a.44.44,0,1,1,0-.88H52a4,4,0,0,0,4-4V50a.44.44,0,0,1,.88,0v2.16A4.84,4.84,0,0,1,52,57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.92,15.06a.44.44,0,0,1-.44-.44V12.45A4.82,4.82,0,0,1,12.3,7.63h2.17a.44.44,0,0,1,.44.44.44.44,0,0,1-.44.44H12.3a4,4,0,0,0-3.94,3.94v2.17A.44.44,0,0,1,7.92,15.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.11,63.11a.43.43,0,0,1-.44-.44V59.5a1.5,1.5,0,0,0-3,0v3.17a.44.44,0,0,1-.88,0V59.5a2.38,2.38,0,0,1,4.75,0v3.17A.44.44,0,0,1,34.11,63.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.5,63.11a.44.44,0,0,1-.44-.44V59.5a3.89,3.89,0,0,0-7.78,0v3.17a.43.43,0,0,1-.44.44.44.44,0,0,1-.44-.44V59.5a4.77,4.77,0,1,1,9.54,0v3.17A.43.43,0,0,1,36.5,63.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.93,64.47a.43.43,0,0,1-.44-.44V51.71a.43.43,0,0,1,.44-.44.44.44,0,0,1,.44.44V64A.44.44,0,0,1,18.93,64.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.39,64.47A.43.43,0,0,1,23,64V51.71a.43.43,0,0,1,.44-.44.44.44,0,0,1,.44.44V64A.44.44,0,0,1,23.39,64.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41,64.47a.44.44,0,0,1-.44-.44V51.71a.44.44,0,0,1,.88,0V64A.44.44,0,0,1,41,64.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.42,64.47A.44.44,0,0,1,45,64V51.71a.44.44,0,1,1,.88,0V64A.44.44,0,0,1,45.42,64.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.93,13.21a.44.44,0,0,1-.44-.45V.44A.44.44,0,0,1,18.93,0a.44.44,0,0,1,.44.44V12.76A.45.45,0,0,1,18.93,13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.39,13.21a.44.44,0,0,1-.44-.45V.44A.44.44,0,0,1,23.39,0a.44.44,0,0,1,.44.44V12.76A.45.45,0,0,1,23.39,13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41,13.21a.45.45,0,0,1-.44-.45V.44a.44.44,0,0,1,.88,0V12.76A.45.45,0,0,1,41,13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.42,13.21a.45.45,0,0,1-.44-.45V.44a.44.44,0,0,1,.88,0V12.76A.45.45,0,0,1,45.42,13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.49,13.21a.45.45,0,0,1-.44-.45V.44a.44.44,0,0,1,.88,0V12.76A.45.45,0,0,1,36.49,13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.55,13.21a.45.45,0,0,1-.44-.45V.44A.44.44,0,0,1,27.55,0,.44.44,0,0,1,28,.44V12.76A.44.44,0,0,1,27.55,13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,13.21a.45.45,0,0,1-.44-.45V.44a.44.44,0,0,1,.88,0V12.76A.45.45,0,0,1,32,13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5,34.65H1.8a.44.44,0,1,1,0-.88H5a1.5,1.5,0,1,0,0-3H1.8a.43.43,0,0,1-.44-.44.44.44,0,0,1,.44-.44H5a2.38,2.38,0,1,1,0,4.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5,37.05H1.8a.44.44,0,0,1-.44-.45.43.43,0,0,1,.44-.43H5a3.89,3.89,0,0,0,0-7.78H1.8A.44.44,0,0,1,1.36,28a.43.43,0,0,1,.44-.44H5a4.77,4.77,0,1,1,0,9.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.77,19.47H.44a.44.44,0,1,1,0-.88H12.77a.44.44,0,1,1,0,.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.77,23.93H.44a.44.44,0,0,1,0-.88H12.77a.44.44,0,1,1,0,.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.77,41.5H.44A.44.44,0,0,1,0,41.06a.44.44,0,0,1,.44-.44H12.77a.44.44,0,0,1,.44.44A.44.44,0,0,1,12.77,41.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.74,46H.44A.44.44,0,0,1,0,45.52a.44.44,0,0,1,.44-.44h11.3a.44.44,0,0,1,.44.44A.43.43,0,0,1,11.74,46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.54,34.65H59.36a2.38,2.38,0,0,1,0-4.75h3.18a.44.44,0,0,1,.44.44.44.44,0,0,1-.44.44H59.36a1.5,1.5,0,0,0,0,3h3.18a.44.44,0,0,1,0,.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.54,37.05H59.36a4.77,4.77,0,0,1,0-9.54h3.18A.44.44,0,0,1,63,28a.44.44,0,0,1-.44.44H59.36a3.89,3.89,0,0,0,0,7.78h3.18a.44.44,0,0,1,.44.43A.45.45,0,0,1,62.54,37.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.9,19.47H51.57a.44.44,0,1,1,0-.88H63.9a.44.44,0,0,1,0,.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.9,23.93H51.57a.44.44,0,0,1,0-.88H63.9a.44.44,0,1,1,0,.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.9,41.5H51.57a.44.44,0,0,1-.44-.44.44.44,0,0,1,.44-.44H63.9a.44.44,0,0,1,.44.44A.44.44,0,0,1,63.9,41.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.9,46H51.57a.44.44,0,0,1-.44-.44.44.44,0,0,1,.44-.44H63.9a.44.44,0,0,1,.44.44A.44.44,0,0,1,63.9,46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.36,53.6a.44.44,0,0,1-.44-.44V49.3a.44.44,0,1,1,.88,0v3.86A.44.44,0,0,1,30.36,53.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.36,48.22a.44.44,0,0,1-.44-.44v-3a.44.44,0,1,1,.88,0v3A.44.44,0,0,1,30.36,48.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.36,43.74a.44.44,0,0,1-.44-.44V41.49a.44.44,0,0,1,.88,0V43.3A.44.44,0,0,1,30.36,43.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,53.6a.44.44,0,0,1-.44-.44V49.3a.45.45,0,0,1,.44-.45.44.44,0,0,1,.44.45v3.86A.43.43,0,0,1,34,53.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,48.22a.44.44,0,0,1-.44-.44v-3a.44.44,0,0,1,.44-.44.43.43,0,0,1,.44.44v3A.43.43,0,0,1,34,48.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,43.74a.44.44,0,0,1-.44-.44V41.49a.44.44,0,0,1,.44-.44.44.44,0,0,1,.44.44V43.3A.44.44,0,0,1,34,43.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.16,53.6a.44.44,0,0,1-.45-.44V52a.45.45,0,0,1,.89,0v1.18A.44.44,0,0,1,32.16,53.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.16,50.92a.45.45,0,0,1-.45-.44V47a.45.45,0,0,1,.89,0v3.44A.44.44,0,0,1,32.16,50.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.16,46a.44.44,0,0,1-.45-.44v-2.4a.45.45,0,0,1,.89,0v2.4A.44.44,0,0,1,32.16,46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36,53.6a.44.44,0,0,1-.44-.44V52a.44.44,0,0,1,.88,0v1.18A.44.44,0,0,1,36,53.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36,50.92a.44.44,0,0,1-.44-.44V47a.44.44,0,0,1,.88,0v3.44A.44.44,0,0,1,36,50.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.4,53.6a.43.43,0,0,1-.44-.44V52a.43.43,0,0,1,.44-.44.44.44,0,0,1,.44.44v1.18A.44.44,0,0,1,28.4,53.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.4,50.92a.44.44,0,0,1-.44-.44V47a.44.44,0,0,1,.44-.44.44.44,0,0,1,.44.44v3.44A.44.44,0,0,1,28.4,50.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.61,44.8h-.06a3.66,3.66,0,0,1-1.46-.39l0,0a2.42,2.42,0,0,0-1.46-.48h-.05a2.71,2.71,0,0,0-1.17.39,3.56,3.56,0,0,1-1.64.51h0a3.24,3.24,0,0,1-1.45-.32l-.07,0a2.63,2.63,0,0,0-1.46-.54h0l-.34,0a.43.43,0,0,1-.49-.38.42.42,0,0,1,.37-.49,2.5,2.5,0,0,1,.45,0,3.61,3.61,0,0,1,2,.69,2.54,2.54,0,0,0,1,.21,2.74,2.74,0,0,0,1.19-.38A3.66,3.66,0,0,1,17.52,43a3.29,3.29,0,0,1,2,.62,2.56,2.56,0,0,0,1.05.28,1.91,1.91,0,0,0,1-.24A3.54,3.54,0,0,1,23.45,43a.43.43,0,0,1,.44.44.44.44,0,0,1-.44.44,2.7,2.7,0,0,0-1.37.49l0,0A2.84,2.84,0,0,1,20.61,44.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.61,46.84h-.06a3.66,3.66,0,0,1-1.46-.39l0,0a2.42,2.42,0,0,0-1.46-.48h-.05a2.71,2.71,0,0,0-1.17.39,3.56,3.56,0,0,1-1.64.51h0a3.24,3.24,0,0,1-1.45-.32l-.07,0a2.63,2.63,0,0,0-1.46-.54h0l-.34,0a.44.44,0,0,1-.49-.38.42.42,0,0,1,.37-.49,2.5,2.5,0,0,1,.45,0,3.46,3.46,0,0,1,2,.7,2.81,2.81,0,0,0,1,.2,2.74,2.74,0,0,0,1.19-.38,3.66,3.66,0,0,1,1.61-.52,3.29,3.29,0,0,1,2,.62,2.56,2.56,0,0,0,1.05.28,1.93,1.93,0,0,0,1-.24,3.54,3.54,0,0,1,1.89-.66.43.43,0,0,1,.44.44.44.44,0,0,1-.44.44,2.7,2.7,0,0,0-1.37.49l0,0A2.84,2.84,0,0,1,20.61,46.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.61,48.88h-.06a3.43,3.43,0,0,1-1.46-.4l0,0A2.42,2.42,0,0,0,17.59,48h-.05a2.71,2.71,0,0,0-1.17.39,3.56,3.56,0,0,1-1.64.51h0a3.4,3.4,0,0,1-1.45-.32l-.07,0A2.63,2.63,0,0,0,11.75,48h0l-.34,0a.44.44,0,0,1-.49-.38.42.42,0,0,1,.37-.49,2.5,2.5,0,0,1,.45,0,3.5,3.5,0,0,1,2,.69,2.54,2.54,0,0,0,1,.21,2.74,2.74,0,0,0,1.19-.38,3.53,3.53,0,0,1,1.61-.52,3.29,3.29,0,0,1,2,.62,2.74,2.74,0,0,0,1.05.28,1.91,1.91,0,0,0,1-.24,3.54,3.54,0,0,1,1.89-.66.43.43,0,0,1,.44.44.44.44,0,0,1-.44.44,2.7,2.7,0,0,0-1.37.49l0,0A2.84,2.84,0,0,1,20.61,48.88Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrenTaita2);
export default __webpack_public_path__ + "static/media/Tren_taita_2.178fc52512a3287af6195f8baacd57cb.svg";
export { ForwardRef as ReactComponent };